<div class="bg-grey-200 page-padding-y pb-6">
  <ng-container *ngIf="committee && !loading">
    <h5 class="page-padding-x text-darkBlue-500 mb-6 break-words" id="h5-committee-code" >{{ committee.committeeCode }}</h5>
    <div class="page-padding-x flex flex-col 2xl:flex-row gap-2 2xl:gap-0">
        <h5 class="w-full 2xl:w-1/3 flex flex-wrap gap-2 justify-start place-items-start break-words">{{ committee.committeeTitle }}</h5>
        <span class="w-full 2xl:w-2/3 flex flex-wrap gap-2 justify-end place-items-end">
          <app-button-export-committee-members
            [committee]="committee"
          ></app-button-export-committee-members>

          <ng-container *ngIf="committee">
            <app-button-export-committee-details
              [committee]="committee"
              [projects]="projects"
            ></app-button-export-committee-details>
          </ng-container>

          <app-button-email-committee-members
            [committeeCode]="committee.committeeCode"
            [displayAsButton]="true"
          ></app-button-email-committee-members>

          <app-button-schedule-committee-meeting
            [committee]="committee"
          ></app-button-schedule-committee-meeting>
        </span>
    </div>
  </ng-container>

  <div class="mt-2 2xl:mt-8">
    <app-recently-viewed-committtees
      (onFinishLoading)="onRecentlyViewedCommitteeFinishedLoading()"
      [reloadRecentlyViewedCommittees]="reloadRecentlyViewedCommittees"
    ></app-recently-viewed-committtees>
  </div>
</div>

<div
  class="flex-1 pt-6 bg-grey-100 page-padding-x page-padding-b max-w-[100vw]"
>
  <ng-container >
    <ng-container *ngIf="!loading && !committee">
      <div class="flex justify-center items-center h-full">
        <p>Unable to get committee details</p>
      </div>
    </ng-container>
    <ng-container *ngIf="committee">
      <app-tab
        #appTab
        [tabs]="tabs"
        id="committeesTab"
        (onTabChange)="onTabChange($event)"
      >
      </app-tab>

      <div [class.hidden]="selectedTab !== this.tabIds.overview">
        <app-card>
          <app-committee-details-overview
            [committee]="committee"
            [loading]="loading"
          ></app-committee-details-overview>
        </app-card>
      </div>
      <div
        [class.hidden]="selectedTab !== this.tabIds.internationalParticipation"
      >
      <app-card>
        <app-committee-details-international-participation
          [internationalMirrorCommittee]="internationalMirrorCommittee"
        ></app-committee-details-international-participation>
      </app-card>
      </div>
      <div [class.hidden]="selectedTab !== this.tabIds.committeeMembership">
        <app-committee-details-committee-membership
          [committee]="committee"
          [loading]="loading"
        ></app-committee-details-committee-membership>
      </div>
      <div [class.hidden]="selectedTab !== this.tabIds.projects">
        <app-committee-details-project
          [loading]="loadingProjects"
          [projects]="projects"
        ></app-committee-details-project>
      </div>
      <div [class.hidden]="selectedTab !== this.tabIds.publications">
        <app-committee-details-publication
          [committeeCode]="committeeCode"
        ></app-committee-details-publication>
      </div>
      <div
        [class.hidden]="
          selectedTab !== this.tabIds.subCommitteesAndWorkingGroups
        "
      >
        <app-sub-committees
          [subCommittees]="subCommittees"
        ></app-sub-committees>
      </div>
      <div
        *ngIf="hasAccessToDeclarationOfInterest"
        [class.hidden]="selectedTab !== this.tabIds.declarationOfInterest"
      >
        <app-committee-details-declaration-of-interest
          [declarationOfInterest]="declarationOfInterest"
          [loading]="loading"
        ></app-committee-details-declaration-of-interest>
      </div>
    </ng-container>
  </ng-container>

</div>
